interface MeasureOptions {
  label: string
  meta?: Record<string, any>
  logLevel?: 'log' | 'debug' | 'warn'
  thresholdMs?: number // Para resaltar lento
}

export async function measureApi<T>(fn: () => Promise<T>, options: MeasureOptions): Promise<T> {
  const { label, meta = {}, logLevel = 'log', thresholdMs = 800 } = options
  const t0 = performance.now()
  let ok = false
  try {
    const result = await fn()
    ok = true
    return result
  } finally {
    const dt = Math.round(performance.now() - t0)
    const base = `[measureApi] ${label} ${ok ? 'OK' : 'ERR'} ${dt}ms`
    const extra = Object.keys(meta).length ? ` meta=${JSON.stringify(meta)}` : ''
    // eslint-disable-next-line no-console
    ;(console as any)[logLevel](dt > thresholdMs ? base + ' ⚠️ lento' + extra : base + extra)
  }
}
